var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShowHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3558",
    "data-name": "Group 3558",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.435,
    height: 22.627,
    viewBox: "0 0 13.435 22.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FFFFFF;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    "data-name": "Rectangle 1965",
    className: "cls-1",
    width: 3,
    height: 16,
    rx: 1.5,
    transform: "translate(11.314) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1966",
    "data-name": "Rectangle 1966",
    className: "cls-1",
    width: 3,
    height: 16,
    rx: 1.5,
    transform: "translate(13.435 20.506) rotate(135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowHide);
export default __webpack_public_path__ + "static/media/Icon_Show-Hide.fe6dce940e4c24677709ba219c6ab7b8.svg";
export { ForwardRef as ReactComponent };